require('../common');
require('../pages/signup/email_validate');
require('../pages/signup/password_validate');
require('../pages/signup/username_validate');
